var exports = {
  "Xe": "FluxerTagChangeModal.module__confirmDescription___NExjQ1",
  "z8": "FluxerTagChangeModal.module__confirmSecondary___NExjQ1",
  "O7": "FluxerTagChangeModal.module__fluxerTagContainer___NExjQ1",
  "To": "FluxerTagChangeModal.module__fluxerTagLabel___NExjQ1",
  "Nr": "FluxerTagChangeModal.module__fluxerTagInputRow___NExjQ1",
  "jo": "FluxerTagChangeModal.module__usernameInput___NExjQ1",
  "me": "FluxerTagChangeModal.module__separator___NExjQ1",
  "vb": "FluxerTagChangeModal.module__discriminatorInput___NExjQ1",
  "xU": "FluxerTagChangeModal.module__discriminatorInputDisabled___NExjQ1",
  "d0": "FluxerTagChangeModal.module__discriminatorOverlay___NExjQ1",
  "Ye": "FluxerTagChangeModal.module__errorBox___NExjQ1",
  "jY": "FluxerTagChangeModal.module__validationBox___NExjQ1",
  "KF": "FluxerTagChangeModal.module__premiumDiscriminatorWarning___NExjQ1",
  "Lu": "FluxerTagChangeModal.module__premiumUpsell___NExjQ1",
};

module.exports = exports;
